import { TransitOperation } from '../models/types'
import { duplicateSubmission } from './http'
import { fromTransitOperationResponse } from '../models/mapper'

// eslint-disable-next-line import/prefer-default-export
export async function duplicateTransitOperation(id: number, withFiles: boolean): Promise<TransitOperation> {
  const response = await duplicateSubmission({
    transitOperationId: id,
    withFiles,
  })

  return fromTransitOperationResponse(response)
}
